<template>
  <div class="mall-advantages">
    <h2>Advantages of<br />our system development</h2>
    <p class="sub-title">グレイトヘルプのシステム開発のメリット</p>

    <div
      class="wrap-right"
      :class="{ 'over-baseline': displayData.advantage01 === true }"
    >
      <p
        class="blue-title transparent"
        :class="{ fadeIn: displayData.advantage01 === true }"
      >
        料金が安い
      </p>
      <p
        class="text transparent"
        :class="{ fadeIn: displayData.advantage01 === true }"
      >
        他社で見積もりを取得したことがある弊社クライアントから提示を受けた実績データでのお話となります。一般的なシステム会社（1～5名程度の超小規模法人や個人事業主を含まない）と比較して、弊社の開発費・保守費はおよそ50～80％程度となっています。そのため、コストメリットから弊社をお選びいただくクライアントが多くいます。弊社が市場で優位性のある価格でシステム開発を行えるのには、以下の理由があります。<br /><br />1つめは会社としての規模と構造です。システム開発は高い技術が必要となるため、必然的に、対応できる会社は、そのような人材を獲得・維持できる大きなシステム会社となります。大きなシステム会社ゆえに、間接部門が多くあることがコストに反映されたり、大手ゆえのプレミアな価格設定になっていたりします。それに対し、弊社は、高い技術を有した従業員が集まりながら、10人規模のコンパクトな会社で、間接部門も多く持たず、また、業務自体もシステムにより合理化しているので、コスト安を実現できます。<br /><br />業界の風習として、大手システム会社は、下請けのシステム会社を利用することもよくあり、そのような体制の場合は、どうしても中間マージンが多く発生してしまうため、料金が高くなってしまいます。弊社は業務の大部分を社内で対応をするため、下請けを使用している企業よりもコストが高くなりづらいです。<br /><br />2つめは地域による相場の違いです。弊社は、岐阜市に拠点があり、岐阜というエリアの相場がそもそも大都市と比較して安いです。そのため、東京・大阪・名古屋などの大都市のクライアントが地域による価格差のメリットを享受するために、弊社へご依頼をいただくこともあります。
      </p>
    </div>

    <div
      class="wrap-left"
      :class="{ 'over-baseline': displayData.advantage02 === true }"
    >
      <p
        class="blue-title transparent"
        :class="{ fadeIn: displayData.advantage02 === true }"
      >
        不要な料金が発生しない見積もり体制
      </p>
      <p
        class="text transparent"
        :class="{ fadeIn: displayData.advantage02 === true }"
      >
        システム開発業界のよろしくない文化ですが、クライアントからシステム開発の依頼があると、受注を早く確定したいがために、推定値で見積書を提示し、契約の締結へと急ごうとすることがよくあります。問題は、この推定値の見積金額です。推定値での見積もりの場合は、どうしても安全率をみた金額になってしまうため、料金が最大値になりがちです。それに対して、弊社は、クライアントに不利益があることをなくすため、打ち合わせを重ね、要件が確定してから見積もりをするため、正当な金額でシステム開発ができます。このように、本来発生しない料金をいただくことはありません。
      </p>
    </div>

    <div class="wrap-right">
      <p class="blue-title">同業他社よりも納期が短い</p>
      <p class="text">
        料金と同じく、システムの開発納期についても、一般的なシステム会社に対して50～80％程度の期間となっています（他社で見積もりを取得したことがある弊社クライアントから提示を受けた実績データによって算出）。この理由も、上述のとおり、弊社は推定値での受注をしていないため、料金同様に、納期についても過度な安全率を考慮する必要がないからです。
      </p>
    </div>

    <div class="wrap-left">
      <p class="blue-title">クライアント目線の提案と制作料金</p>
      <p class="text">
        弊社はクライアントのご希望とご予算に合わせて、クライアントごとに制作するシステムの内容を提案しています。
      </p>
      <ul>
        <li>目的達成するためのフルスペックなシステムを制作することも可能</li>
        <li>予算内で実現できるベストなシステムを提案することも可能</li>
        <li>
          コストをなるべく落とすことを優先したシステムを提案することも可能
        </li>
      </ul>
      <p class="text">
        このように、クライアントごとに、システム化したい業務の対象や予算などをヒアリングの上、クライアントのニーズにマッチし、クライアントにとってベストなシステムをご提案しています。
      </p>
    </div>

    <div class="wrap-right">
      <p class="blue-title">知識がなくてもシステム化できる</p>
      <p class="text">
        お困りごとや、システム化したい対象について、詳しくお伝えさえいただければ、どのようなシステムにするとよいかは弊社から提案させていただくことが可能です。そのため、社内の文化としてITに弱かったり、社内のシステム専門の人員がいなくても、システム化ができます。
      </p>
    </div>

    <div class="wrap-left">
      <p class="blue-title">考えられたスマートな設計</p>
      <p class="text">
        プログラムの技術は、ある程度の学力がある人が勉強すれば誰でも身につくものですが、考えられたスマートな設計、合理的な設計は、そうではありません。弊社は、スマートな設計を強みとしており、スマートな設計の制作物を提供することができます。使用者を想定した設計を方針としており、使用者を無視した設計はしていません。
      </p>
    </div>

    <div class="wrap-right sp-bottom">
      <p class="blue-title">柔軟なコスト調整</p>
      <p class="text">
        弊社は、システム開発のみならず、ホームページ制作、ECサイト制作など、幅広いIT案件に対応しており、弊社で開発したいかなる案件ともシステムの連携が可能です。ECサイトで受けた注文が顧客管理システムに自動で入り、そこから売上管理システムへも売上データを飛ばして集計するなど、システム全体での業務の合理化が可能です。
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import UiBox4 from "@/components/Ui/Box4.vue";

export default {
  name: "mall-advantages",
  components: {
    // UiBox4
  },
  data() {
    return {
      documentheight: 0,
      //
      displayData: {
        advantage01: false,
        advantage02: false,
      },
    };
  },
  computed: {
    ...mapGetters(["rootUrl", "scrollY"]),
  },
  watch: {
    scrollY(newValue) {
      // advantage01
      if (newValue >= 10000) {
        this.displayData.advantage01 = true;
      }

      // advantage02.

      if (newValue >= 11700) {
        this.displayData.advantage02 = true;
      }

      // advantage03
      //
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.wrap-left,
.wrap-right {
  background-color: var(--sub3);
  margin-bottom: 50px;
  transition: all 0.8s ease;
  // clip-path: polygon(0 0, 0 0, 0 0, 0 0);
  @media screen and (max-width: 767px) {
    margin-bottom: 5px;
  }

  .blue-title {
    color: var(--main);
    font-size: 25px;
    margin-bottom: 20px;
    font-weight: 500;
    @media screen and (max-width: 767px) {
      font-size: 23px;
      line-height: 1.5em;
    }
  }
  .text {
    color: var(--black);
    line-height: 2;
  }
  // .transparent {
  //   opacity: 0;
  // }
  .fadeIn {
    transition: opacity 2s 0.8s;
    opacity: 1;
  }
  :deep(ul) {
    margin: 30px 0;
  }
  @media screen and (max-width: 767px) {
    margin-right: 0;
    padding-left: 20px;
    padding-right: 20px;
  }
}
.over-baseline {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%) !important;
}

.wrap-left {
  margin-left: calc(calc(100vw - 1100px) * 0.5);
  padding: 50px calc(calc(calc(100vw - 1150px) * 0.5) + 105px) 50px 80px;
  @media screen and (max-width: 1024px) {
    margin-left: 0;
    padding: 40px 20px;
  }
}
.wrap-right {
  margin-right: calc(calc(100vw - 1100px) * 0.5);
  padding: 50px 100px 50px calc(calc(calc(100vw - 1150px) * 0.5) + 105px);
  @media screen and (max-width: 1024px) {
    margin-right: 0;
    padding: 40px 20px;
  }
}
.wrap-left:last-child{
        @media screen and (min-width:768px) and ( max-width:1024px){
      margin-bottom: 0;
      }
}
:deep(h2),
.sub-title,
p {
  color: white;
}

:deep(.link-button) {
  a {
    color: white;
    border: white 1px solid;
    &:hover {
      background-color: white;
      color: var(--sub);
    }
  }
}
.sp-bottom{
      @media screen and (max-width: 1024px) {
    margin-bottom: 0;
    }
}

.over-baseline {
  clip-path: polygon(0 0, 200% 0, 0 200%);
}
</style>
